// src/components/ThemeToggle.js
import React, { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext"; // Use lowercase 'context'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";

const ThemeToggle = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <button
      onClick={toggleTheme}
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        width: "40px",
        height: "40px",
        backgroundColor: "var(--primary-color)",
        borderRadius: "50%",
        border: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        boxShadow: "0 4px 8px var(--shadow-color)",
        transition: "background-color 0.2s ease, transform 0.2s ease",
      }}
      onMouseOver={(e) => (e.target.style.transform = "scale(1.1)")}
      onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
      title={theme === "light" ? "Switch to Dark Mode" : "Switch to Light Mode"}
    >
      <FontAwesomeIcon
        icon={theme === "light" ? faMoon : faSun}
        style={{
          color: "#ffffff",
          fontSize: "1.5rem",
          transition: "transform 0.3s ease, opacity 0.3s ease",
          transform: theme === "light" ? "rotate(0deg)" : "rotate(180deg)",
          opacity: theme === "light" ? 0.8 : 1,
        }}
      />
    </button>
  );
};

export default ThemeToggle;